/**
 * 是否为IE
 */
export default /msie/i.test(navigator.userAgent) && !window.opera



// WEBPACK FOOTER //
// ./src/packages/utils/src/isIE.js